import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';

import Field from 'components/Field';
import Input from 'components/Input';
import styles from './AcademyProjectDetails.module.scss';

export default function AcademyProjectDetails({ academyProjectDetails }) {
  const {
    academyProjectTestId,
    academyProjectTitle,
    metaDailyReduction,
    metaMaxReduction,
    metaOffset,
    metaWindow,
  } = academyProjectDetails || {};

  const formattedWindowOffset = useCallback(
    (value) => Math.floor((value || 0) / (60 * 60 * 24)),
    []
  );

  return (
    <>
      <Field
        name="title"
        label="Case Study slug ID"
      >
        <Input
          className={styles.inputField}
          value={academyProjectTestId}
          disabled
        />
        <Tappable
          className="link m-l-s"
          href={`/admin/academy-course-info`}
          noHighlight
          target="_blank"
        >
          Business Case link
        </Tappable>
      </Field>
      <Field
        label="Business Case Study Title"
        hint="Please manage Case Study below"
      >
        <Input
          className={styles.inputField}
          value={academyProjectTitle}
          disabled
        />
      </Field>
      <div className="row wrap m-t-m">
        <Field
          label="Daily Reduction"
          className="m-r-xs"
          labelClassName={styles.fieldLabel}
        >
          <Input
            disabled
            className={styles.input}
            value={metaDailyReduction}
          />
        </Field>
        <Field
          label="Max Reduction"
          className="m-r-xs"
          labelClassName={styles.fieldLabel}
        >
          <Input
            disabled
            className={styles.input}
            value={metaMaxReduction}
          />
        </Field>
        <Field
          label="Window"
          className="m-r-xs"
          labelClassName={styles.fieldLabel}
        >
          <Input
            value={`${formattedWindowOffset(metaWindow)} Days`}
            disabled
            className={styles.input}
          />
        </Field>
        <Field
          label="Offset"
          labelClassName={styles.fieldLabel}
        >
          <Input
            value={`${formattedWindowOffset(metaOffset)} Days`}
            disabled
            className={styles.input}
          />
        </Field>
      </div>
    </>
  );
}
